module.exports = __webpack_public_path__ + "static/media/square.823240ed.svg";